import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { useAuth } from 'hooks'
import { ROUTES } from 'routes'
import { PENDING_POST_AUTH_STEP_KEY } from 'utils/postAuthStep'

export const ProtectedAuthRoute = (props: any) => {
  const { redirectPath = ROUTES.HOME } = props

  const { isAuthenticated } = useAuth()

  // VERA-842: an auth surface can own a step that runs AFTER the session is
  // minted (e.g. "set a new password" at the end of a password reset). Without
  // this escape the guard bounces the user to HOME the instant the token lands
  // and that step never renders.
  const hasPendingPostAuthStep =
    typeof window !== 'undefined' &&
    window.sessionStorage.getItem(PENDING_POST_AUTH_STEP_KEY) === '1'

  // Declarative redirect: the previous `navigate()` ran DURING render, which
  // React flags ("Cannot update a component while rendering a different one").
  if (isAuthenticated && !hasPendingPostAuthStep) {
    return <Navigate to={redirectPath} replace />
  }

  return <Outlet />
}
